import "./produit.css";
import leftArrow from "../assets/left-arrow.png";
import rightArrow from "../assets/right-arrow.png";
import information from "../assets/information.png";
import Dashboard from "../components/dashboard/Dashboard.js";
import product from "../assets/product.jpg";
import product2 from "../assets/product2.jpg";
import heartShape from "../assets/heartShape.png";
import React, { useEffect, useState } from "react";

function Outfit({ top, heart, ventes, commission, produit }) {
  return (
    <div className="product">
      <div className="flex_div">
        <div
          style={{
            width: "100%",
            height: "100%",
            backgroundImage: `url(${produit})`,
            backgroundSize: "cover",
            border: "5px solid #c2c2c2",
            borderRadius: "5px",
          }}
        />
        <div className="likes">
          <h4 className="disc">Le 12 janvier 2023</h4>
          <div style={{ display: "flex", alignItems: "center" }}>
            <img className="heart_image" src={heartShape} alt="heart" />
            <h4 className="disc">{heart}</h4>
          </div>
        </div>
      </div>
      <div className="flex_div">
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className="green" />
          <h4 className="product_title">
            {heart}
            {"%"}
          </h4>
        </div>
        <h4 className="product_text">Taux de conversion</h4>
        <div className="element_devider" />
        <h4 className="product_title">{ventes} ventes</h4>
        <div>
          <h4 className="disc">35 Vestes</h4>
        </div>
        <div>
          <h4 className="disc">30 Chemises</h4>
        </div>
        <div>
          <h4 className="disc">12 Sacs</h4>
        </div>
        <div className="element_devider" />
        <h4 className="product_title">1050€</h4>
        <div>
          <h4 className="disc">en commission</h4>
        </div>
      </div>
    </div>
  );
}

export default Outfit;
